﻿import { RouterProvider } from 'react-router-dom';

// project imports
import router from './routes';
import ThemeCustomization from './themes';

import ScrollTop from './components/ScrollTop';
import AutoReloadOnNewBuild from './components/AutoReloadOnNewBuild';
import { AuthProvider } from './hooks/useAuth';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
      <AutoReloadOnNewBuild intervalMs={15_000} />
      <AuthProvider>
        <ScrollTop>
          <RouterProvider router={router} />
        </ScrollTop>
      </AuthProvider>
    </ThemeCustomization>
  );
}

